import styled from "styled-components";

interface IContainer {
  aberto: boolean;
}

export const Container = styled.div<IContainer>`
  color: ${({ theme }) => theme.colors.neutral.neutral70};
  position: absolute;
  right: 225px;
  top: 165px;
  background-color: #ffffff;
  box-shadow: -2px 0 8px rgb(0, 0, 0, 20%), 2px 0 8px rgb(0, 0, 0, 20%),
    0 -2px 8px rgb(0, 0, 0, 20%), 0 2px 8px rgb(0, 0, 0, 20%);
  border-radius: 5px;
  z-index: 100;
  font-size: 14px;
  display: ${({ aberto }) => (aberto ? "block" : "none")};
  padding: 12px 0;
`;

export const Titulo = styled.div`
  font-weight: 600;
  text-align: left;
  margin-bottom: 8px;

  svg {
    width: 14px;
    height: 14px;
    margin-bottom: 5px;
  }
`;

export const Opcao = styled.div`
  font-weight: 400;
  text-align: left;
  width: 215px;
  padding: 12px;
`;

export const TextoOpcao = styled.span`
  cursor: pointer;
`;

export const OpcaoTitulo = styled.div`
  font-weight: 700;
  text-align: left;
  width: 215px;
  padding: 12px 6px 6px 12px;
`;

export const TextoClaro = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral50};
`;
